import { VisibilityRounded } from '@mui/icons-material'
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import FavoriteButton from '../../../../shared/components/buttons/FavoriteButton'
import useStyles from '../../../../shared/styles/UsersStyles'
import { FavoriteItem as FavoriteItemType } from '../../models/favorites'

interface FavoriteItemProps {
  item: FavoriteItemType
  resourceType: string
  indexPath: string
  historyPath: string
  imgPath: string
  onFavoriteClick: (id: number, type: string, indexPath: string) => (_: boolean) => void
  onRedirectClick: (type: string, path: string, data: FavoriteItemType) => void
}

const FavoriteItem = ({ item, resourceType, indexPath, historyPath, imgPath, onFavoriteClick, onRedirectClick }: FavoriteItemProps) => {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const classes = useStyles()

  return (
    <Grid item xs={12} sm={6} lg={4}>
      <Box
        sx={{
          height: 40,
          padding: '1px',
          bgcolor: 'grey.100',
          borderRadius: 0.5,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          onClick={() => onRedirectClick(resourceType, historyPath, item)}
          sx={{ cursor: 'pointer', maxWidth: 'calc(100% - 96px)' }}
        >
          <img
            src={imgPath === 'courses' ? `${item.image}` : `${import.meta.env.VITE_AWS_URL}/${imgPath}/webp/${item.image}`}
            title={item.title}
            alt={item.title}
            style={{ height: 40, width: 40, borderRadius: 8, backgroundColor: theme.palette.grey[400] }}
          />
          <Tooltip title={item.title}>
            <Typography sx={classes.titleFav}>{item.title}</Typography>
          </Tooltip>
        </Box>
        <Box>
          <FavoriteButton handleClick={onFavoriteClick(item.id, resourceType, indexPath)} favoriteState={true} />
          <Tooltip title={t('view')}>
            <IconButton onClick={() => onRedirectClick(resourceType, historyPath, item)}>
              <VisibilityRounded />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Grid>
  )
}

export default FavoriteItem
